export default "__VITE_ASSET__BWE7JWUf__"